import { FC } from 'react';
import { useContextSelector } from 'use-context-selector';
import PoRelatedDocuments from '../po_related_documents/PoRelatedDocuments';
import { InvoiceContext } from './InvoiceDetailsContext';
interface InvoiceDetailsRelatedDocumentsProps {
  isDirty: boolean;
}

const InvoiceDetailsRelatedDocuments: FC<InvoiceDetailsRelatedDocumentsProps> = ({ isDirty }) => {
  const poId = useContextSelector(InvoiceContext, (value) => value.poId);
  const refreshPage = useContextSelector(InvoiceContext, (value) => value.refreshPage);
  const showScans = useContextSelector(InvoiceContext, (value) => value.showScans);
  const isInvoiceDirty = useContextSelector(InvoiceContext, (value) => value.isInvoiceDirty);
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const setLinkedReceiptQuantity = useContextSelector(
    InvoiceContext,
    (value) => value.setLinkedReceiptQuantity
  );
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );

  return (
    <PoRelatedDocuments
      poId={poId}
      poNumber={invoice?.poNum}
      refreshDetails={refreshPage}
      poStatus={invoice?.poStatus}
      isInvoice={true}
      setLinkedDocQuantity={setLinkedReceiptQuantity}
      isDirty={isInvoiceDirty}
      isEditDisabled={isInvoiceEditDisabled}
      gridKey={`${showScans}`}
    />
  );
};

export default InvoiceDetailsRelatedDocuments;
